import {
    ConvertBookingToWaitlistComponentProps,
    ConvertWaitlistToBookingComponentProps,
    GetBookedAttendeesByCourseIdDocument,
    GetBookingsByAttendeeIdWithOptionsDocument,
    GetBookingsByCourseDocument,
    GetBookinsDocument,
    GetBookingsOverviewOptimizedDocument,
    GetCourseByIdDocument,
    GetCourseDetailsByIdDocument,
    GetFreePlacesByCourseIdDocument,
    GetScheduledPaymentsByBookingIdDocument,
    GetSettledBookingsDocument,
    GetUnsettledBookingsDocument,
    GetWaitlistByCourseDocument,
    RemoveBookingsComponentProps,
    SendBookingConfirmationComponentProps,
} from "../../../../generated/graphql";

export const refetchQueriesForAll = ({
    bookingId,
    courseId,
    attendeeId,
}: {
    bookingId: string;
    courseId?: string;
    attendeeId?: string;
}):
    | RemoveBookingsComponentProps["refetchQueries"]
    | ConvertBookingToWaitlistComponentProps["refetchQueries"]
    | ConvertWaitlistToBookingComponentProps["refetchQueries"]
    | SendBookingConfirmationComponentProps["refetchQueries"] => {
    const refetchQueries: Array<string | {query: any; variables?: any}> = [
        "GetBookins",
        {
            query: GetBookinsDocument,
        },
        "GetBookingsOverviewOptimized",
        {
            query: GetBookingsOverviewOptimizedDocument,
        },
        "GetUnsettledBookings",
        {
            query: GetUnsettledBookingsDocument,
        },
        "GetSettledBookings",
        {query: GetSettledBookingsDocument},
        "GetScheduledPaymentsByBookingId",
        {
            query: GetScheduledPaymentsByBookingIdDocument,
            variables: {bookingId},
        },
    ];

    if (courseId) {
        refetchQueries.push(
            "GetFreePlacesByCourseId",
            {
                query: GetFreePlacesByCourseIdDocument,
                variables: {id: courseId},
            },
            "GetBookingsByCourse",
            {
                query: GetBookingsByCourseDocument,
                variables: {id: courseId},
            },
            "GetBookedAttendeesByCourseId",
            {
                query: GetBookedAttendeesByCourseIdDocument,
                variables: {courseId},
            },
            "GetWaitlistByCourse",
            {
                query: GetWaitlistByCourseDocument,
                variables: {id: courseId},
            },
            "GetCourseById",
            {
                query: GetCourseByIdDocument,
                variables: {id: courseId},
            },
            "GetCourseDetailsById",
            {
                query: GetCourseDetailsByIdDocument,
                variables: {id: courseId},
            },
        );
    }

    if (attendeeId) {
        refetchQueries.push("GetBookingsByAttendeeIdWithOptions", {
            query: GetBookingsByAttendeeIdWithOptionsDocument,
            variables: {id: attendeeId},
        });
    }

    return refetchQueries;
};
